var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup10616(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 98,
    viewBox: "0 0 101 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 47,
    r: 47,
    fill: "#FBE1E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 51,
    r: 45.5,
    stroke: "#1C1C1C",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.375 67.771C42.4105 67.771 43.25 66.9315 43.25 65.896C43.25 64.8605 42.4105 64.021 41.375 64.021C40.3395 64.021 39.5 64.8605 39.5 65.896C39.5 66.9315 40.3395 67.771 41.375 67.771Z",
    stroke: "#1C1C1C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.125 67.771C61.1605 67.771 62 66.9315 62 65.896C62 64.8605 61.1605 64.021 60.125 64.021C59.0895 64.021 58.25 64.8605 58.25 65.896C58.25 66.9315 59.0895 67.771 60.125 67.771Z",
    stroke: "#1C1C1C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 32.146H35.0682L39.6364 55.5779C39.7922 56.3836 40.2192 57.1073 40.8424 57.6224C41.4657 58.1375 42.2455 58.4111 43.0455 58.3954H59.6136C60.4136 58.4111 61.1934 58.1375 61.8167 57.6224C62.4399 57.1073 62.8669 56.3836 63.0227 55.5779L65.75 40.8958H36.7727",
    stroke: "#1C1C1C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10616);
export default __webpack_public_path__ + "static/media/group-10616.ed21004a15c46f584988cd872fa0f436.svg";
export { ForwardRef as ReactComponent };